export function isAddressValid(address) {
  return !!(address && address.line1 && address.city && address.region && address.country && address.postalCode)
}
